export default __webpack_public_path__ + "static/media/medial_b.5803d4f7.jpg";